import { render, staticRenderFns } from "./supplyHall.vue?vue&type=template&id=311efe1c&scoped=true"
import script from "./supplyHall.vue?vue&type=script&lang=js"
export * from "./supplyHall.vue?vue&type=script&lang=js"
import style0 from "./supplyHall.vue?vue&type=style&index=0&id=311efe1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311efe1c",
  null
  
)

export default component.exports